import { createSlice } from '@reduxjs/toolkit';

import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';

import { createProjectVenue } from './actions/create-project-venue.action';
import { editProjectVenue } from './actions/edit-project-venue.action';
import { getProjectVenue } from './actions/get-project-venue.action';
import { getProjectsVenue } from './actions/get-projects-venue.action';

export type ProjectVenueState = {
  items: ProjectVenue[];
  current: ProjectVenue | null;
  isFetchingProjects: boolean;
  isFetchingCurrentProject: boolean;
  isCreatingProject: boolean;
  isEditingProject: boolean;
};

const initialState: ProjectVenueState = {
  items: [],
  current: null,
  isFetchingProjects: false,
  isFetchingCurrentProject: false,
  isCreatingProject: false,
  isEditingProject: false,
};

export const projectVenueSlice = createSlice({
  name: 'projectVenue',
  initialState,
  reducers: {
    clearCurrent(state) {
      state.current = null;
    },
  },
  extraReducers(builder) {
    builder
      // getProjectsVenue
      .addCase(getProjectsVenue.pending, (state) => {
        state.isFetchingProjects = true;
      })
      .addCase(getProjectsVenue.fulfilled, (state, action) => {
        state.isFetchingProjects = false;
        state.items = action.payload;
      })
      .addCase(getProjectsVenue.rejected, (state) => {
        state.isFetchingProjects = false;
      })
      // getProjectVenue
      .addCase(getProjectVenue.pending, (state) => {
        state.isFetchingCurrentProject = true;
      })
      .addCase(getProjectVenue.fulfilled, (state, action) => {
        state.isFetchingCurrentProject = false;
        state.current = action.payload;
      })
      .addCase(getProjectVenue.rejected, (state) => {
        state.isFetchingCurrentProject = false;
      })
      // createProjectVenue
      .addCase(createProjectVenue.pending, (state) => {
        state.isCreatingProject = true;
      })
      .addCase(createProjectVenue.fulfilled, (state) => {
        state.isCreatingProject = false;
      })
      .addCase(createProjectVenue.rejected, (state) => {
        state.isCreatingProject = false;
      })
      // editProjectVenue
      .addCase(editProjectVenue.pending, (state) => {
        state.isEditingProject = true;
      })
      .addCase(editProjectVenue.fulfilled, (state) => {
        state.isEditingProject = false;
      })
      .addCase(editProjectVenue.rejected, (state) => {
        state.isEditingProject = false;
      });
  },
});
